import { Component, ElementRef, signal, output, ViewChild, input, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { addZoomPan } from './preview';

@Component({
  standalone: true,
  selector: 'webstore-pinch-zoom',
  templateUrl: './pinch-zoom.component.html',
  styleUrls: ['./pinch-zoom.component.scss'],
  imports: [CommonModule]
})
export class PinchZoomComponent {

  @ViewChild('imageContainer') imageContainer!: ElementRef;
  @ViewChild('image') image!: ElementRef;



  readonly imageSrcInput = input<string>("");
  private _imageSrc = signal<string>("");

  get imageSrc() {
    return this._imageSrc();
  }

  // Update outputs to use Angular 20 output() function
  moveToNextSlide$ = output<boolean>();
  moveToPreviousSlide$ = output<boolean>();

  addZoomPan: any;
  startXPosition = 0;
  startYPosition = 0;
  translateX = 0;

  constructor() {
    effect(() => {
      const imageSrcValue = this.imageSrcInput();
      this.addZoomPan?.reset();
      this.addZoomPan?.destroy();
      this._imageSrc.set(imageSrcValue);
    });
  }

  ngOnInit(): void {
    document.addEventListener('touchstart', (event: TouchEvent) => {
      if (event.changedTouches?.[0]) {
        this.startXPosition = event.changedTouches[0].clientX;
        this.startYPosition = event.changedTouches[0].clientY;
      }
    });

    document.addEventListener('touchend', (event: TouchEvent) => {
      if (!event.changedTouches?.[0]) return;

      const currentXPosition = event.changedTouches[0].clientX;
      const currentYPosition = event.changedTouches[0].clientY;

      // Calculate the differences in X and Y positions
      const deltaX = currentXPosition - this.startXPosition;
      const deltaY = currentYPosition - this.startYPosition;

      // Define thresholds for diagonal detection
      const diagonalThreshold = 0.5; // Adjust this as needed (0.5 means 45-degree tolerance)
      const ratio = Math.abs(deltaY / deltaX);

      // Checking if swipe is horizontal
      if (ratio < diagonalThreshold) {
        if (currentXPosition > this.startXPosition) {
          this.moveToPreviousSlide$.emit(true);
        } else if (currentXPosition < this.startXPosition) {
          this.moveToNextSlide$.emit(true);
        }
      }

      /* ORIGINAL COMPLEX LOGIC (COMMENTED OUT DUE TO TYPESCRIPT ERRORS)
      // Original code that handled zoomed states and complex navigation:
      const currentScale = event.detail?.instance?.getScale();

      // Checking is swipe is horizontal
      if (ratio < diagonalThreshold) {
        if (currentScale === 1) {
          if (currentXPosition > this.startXPosition) {
            this.moveToPreviousSlide$.emit(true)
          } else if (currentXPosition < this.startXPosition) {
            this.moveToNextSlide$.emit(true);
          }
        } else {
          const transform = this.image.nativeElement.style.transform;
          const matrix = transform?.match(/matrix\(([^)]+)\)/)[1]?.split(',')?.map(parseFloat);
          const currentTranslateX = matrix[4];
          if (this.translateX === currentTranslateX) {
            if (currentTranslateX > 0) {
              this.moveToPreviousSlide$.emit(true);
            } else if (currentTranslateX < 0) {
              this.moveToNextSlide$.emit(true);
            }
          }
          this.translateX = currentTranslateX;
        }
      }
      */
    });
  }


  addZoom() {
    this.addZoomPan = addZoomPan({ container: this.imageContainer?.nativeElement, image: this.image?.nativeElement });
  }
}

